import type { Language } from '@apiTypes';
import { SuggestionType, useSuggestProductsQueryAPI } from '@apiTypes';
import useStoreAndLanguageParams from '../../core/hooks/useStoreAndLanguageParams';

const useSuggestCategories = ({
    search,
    skip,
}: {
    search: string;
    skip?: boolean;
}) => {
    const { store, language } = useStoreAndLanguageParams();

    const { data, ...response } = useSuggestProductsQueryAPI({
        variables: {
            filters: {
                type: SuggestionType.Category,
                search,
            },
            context: {
                storeCode: store,
                language: language as Language,
            },
            limit: 10,
        },
        skip,
    });

    const items = data?.suggestProducts.items || [];
    const categories = items.map(({ entityId, value, parentCategoryName }) => ({
        id: entityId || '',
        name: value[language],
        parentName: parentCategoryName?.[language],
    }));

    return {
        categories,
        ...response,
    };
};

export default useSuggestCategories;
